import { Instance } from 'mobx-state-tree';
import { DriverDtoModelBase } from './DriverDtoModel.base';
import { formatPhoneToInternational } from '../../../helpers/forms/phoneUtils';
import getInitials from '../utils/getInitials';

/* The TypeScript type of an instance of DriverDtoModel */
export interface DriverDtoModelType extends Instance<typeof DriverDtoModel.Type> {
}

/* A graphql query fragment builders for DriverDtoModel */
export { selectFromDriverDto, driverDtoModelPrimitives, DriverDtoModelSelector } from './DriverDtoModel.base';

/**
 * DriverDtoModel
 */
export const DriverDtoModel = DriverDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }))
  .views((self) => ({
    get initials(): string {
      return getInitials(self.name as string);
    },
    get formattedPhone(): string | undefined {
      return self.user?.phone ? formatPhoneToInternational(self.user.phone) : undefined;
    },
    get email(): string | undefined {
      return self.user?.email || self.invite?.email || self.userInvite?.email || undefined;
    },
  }));
